import { Component, OnInit, Input } from '@angular/core';
import { SieniService } from '../../services/sieni.service';
import { Treatment } from '../../services/treatment';
import { MCause } from '../../models/cause.model';
import { GlobalsService } from '../../services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'Analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.scss']
})
export class AnalysisComponent implements OnInit {

  @Input() public gncId: string;
  @Input() public phaseId: string;


  public textTitleIshikawa:string;
  public textTitleBecause:string;
  public textTitlePareto:string;
  public textTitleOthers:string;


  other: any[] = null;
  five: any[] = null;
  ishikawa: any[] = null;
  pareto: any[] = null;
  rain: any[] = null;
  dataTreatment: any = null
  loading: boolean = false;
  definitiveCauses: MCause[] = null;

  constructor(private sieni: SieniService, private treatment: Treatment,
    private globalService: SieniService, private translate:TranslateService) { }

  ngOnInit() {

    this.textTitleIshikawa = this.translate.instant('treatment.methods.ishikawa.title');
    this.textTitleBecause = this.translate.instant('treatment.methods.because.title');
    this.textTitlePareto = this.translate.instant('treatment.methods.pareto.title');
    this.textTitleOthers = this.translate.instant('treatment.methods.others.title');

    this.loading = true;
    this.sieni.getAllNonConformityCauses(parseInt(this.gncId)).subscribe(resp => {
      // console.log(resp);

      this.treatment.idTreatment(this.gncId).subscribe((result: any) => {

        if (result.title == 'OK') {
          this.dataTreatment = result.data;
          this.other = resp.others;
          this.five = resp.five;
          this.ishikawa = resp.ishikawa;
          this.pareto = resp.pareto
          this.rain = resp.rain;
          this.loading = false;
          // console.log(this.dataTreatment, this.other, this.five, this.ishikawa, this.pareto, this.rain);
        }

      });
    },err => {
      console.error(err.message);
    });

    this.getDefinitveCauses();
  }

  public getDefinitveCauses(){
    // console.log('Entra');
    this.globalService.getNonConformityDefinitiveCauses(+this.gncId).subscribe((res: any) => {
        this.definitiveCauses = res
        // console.log(this.definitiveCauses);
        // this.getAllCauses()
    })
}

}
